import axios from 'axios'

export async function isFromUS() {
  const { headers } = await axios.head('/')
  return !!headers && !!headers['x-country'] && headers['x-country'].toLowerCase() === 'us'
}

export default {
  isFromUS,
}
